// Copyright (c) 2017 Deere & Company

import ClaimDebit from '../../tcsm/claim-debit/components';

export default {
    component: ClaimDebit,
    name: 'CLAIM_DEBIT',
    path: 'claim-debit'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/claim-debit.js